export interface CostPostRequest {
  costCategoryId: number;
  detail: string;
  date: string;
  price: number;
}

export const EmptyCostPostRequest: CostPostRequest = {
  costCategoryId: 0,
  detail: '',
  date: '',
  price: 0,
};
